export default "__VITE_ASSET__Z7vkui_k__"